import { Controller } from "@hotwired/stimulus"

// Manages a single permission category section:
// - Collapsible body (accordion), open state set server-side
// - "Select all" checkbox with indeterminate state
// - Search filter by permission name/key
// - Live "assigned / total" count in the header
export default class extends Controller {
  static targets = [
    "selectAll",
    "checkbox",
    "permissionItem",
    "search",
    "noResults",
    "content",
    "chevron",
    "assignedCount",
  ]

  connect() {
    if (this.hasSelectAllTarget) {
      this.updateSelectAll()
    }
    this.syncChevron()
  }

  // Collapse/expand the category body
  toggle() {
    this.contentTarget.classList.toggle("hidden")
    this.syncChevron()
  }

  expand() {
    this.contentTarget.classList.remove("hidden")
    this.syncChevron()
  }

  collapse() {
    this.contentTarget.classList.add("hidden")
    this.syncChevron()
  }

  isOpen() {
    return (
      this.hasContentTarget && !this.contentTarget.classList.contains("hidden")
    )
  }

  syncChevron() {
    if (!this.hasChevronTarget || !this.hasContentTarget) return
    const isOpen = !this.contentTarget.classList.contains("hidden")
    this.chevronTarget.classList.toggle("rotate-180", isOpen)
  }

  // Called when "Select all" is toggled
  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach((cb) => {
      cb.checked = checked
    })
    this.selectAllTarget.indeterminate = false
    this.updateAssignedCount()
  }

  // Called when any individual permission checkbox changes
  updateSelectAll() {
    const total = this.checkboxTargets.length
    const checkedCount = this.checkboxTargets.filter((cb) => cb.checked).length

    this.selectAllTarget.checked = checkedCount === total
    this.selectAllTarget.indeterminate =
      checkedCount > 0 && checkedCount < total
    this.updateAssignedCount()
  }

  updateAssignedCount() {
    if (!this.hasAssignedCountTarget) return
    const total = this.checkboxTargets.length
    const checkedCount = this.checkboxTargets.filter((cb) => cb.checked).length
    this.assignedCountTarget.textContent = `${checkedCount} / ${total}`
  }

  // Called on search input
  filter() {
    const query = this.searchTarget.value.toLowerCase().trim()

    let visibleCount = 0
    this.permissionItemTargets.forEach((item) => {
      const name = (item.dataset.permissionName || "").toLowerCase()
      const key = (item.dataset.permissionKey || "").toLowerCase()
      const matches = !query || name.includes(query) || key.includes(query)

      item.classList.toggle("hidden", !matches)
      if (matches) visibleCount++
    })

    if (this.hasNoResultsTarget) {
      this.noResultsTarget.classList.toggle("hidden", visibleCount > 0)
    }

    // Typing in a collapsed category should reveal its matches
    if (query) this.expand()
  }
}
